/**
 * navIcons — ultra-light line-icon set for the mega-menu, keyed by string so
 * navTree items can reference an icon by name. Fleet = top-view quadcopter;
 * Shows = a dotted star "drone-show formation". 24×24 viewBox, 1.5 stroke.
 */
import React from 'react';

const ICONS: Record<string, React.ReactNode> = {
  // domains
  drone: (
    <>
      <circle cx="4.6" cy="4.6" r="2.6" />
      <circle cx="19.4" cy="4.6" r="2.6" />
      <circle cx="4.6" cy="19.4" r="2.6" />
      <circle cx="19.4" cy="19.4" r="2.6" />
      <path d="M6.5 6.5l2.9 2.9M17.5 6.5l-2.9 2.9M6.5 17.5l2.9-2.9M17.5 17.5l-2.9-2.9" />
      <rect x="8.9" y="8.9" width="6.2" height="6.2" rx="1.6" />
    </>
  ),
  formation: (
    <>
      <path
        d="M12 3 14.3 8.7 20.6 9.1 15.6 13.1 17.3 19.3 12 15.9 6.7 19.3 8.4 13.1 3.4 9.1 9.7 8.7Z"
        strokeOpacity={0.38}
      />
      <circle cx="12" cy="3" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="20.6" cy="9.1" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="17.3" cy="19.3" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="6.7" cy="19.3" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="3.4" cy="9.1" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="12" cy="11.5" r="1.1" fill="currentColor" stroke="none" />
    </>
  ),
  warehouse: (
    <>
      <path d="M3 21V9l9-6 9 6v12" />
      <path d="M3 21h18M9 21v-6h6v6" />
    </>
  ),
  sales: (
    <>
      <path d="M6 2l1.5 4h9L18 2M4 6h16l-1.5 11H5.5z" />
      <circle cx="9" cy="21" r="1.4" />
      <circle cx="16" cy="21" r="1.4" />
    </>
  ),
  service: (
    <>
      <path d="M14 7l3 3-8 8-3-3z" />
      <path d="M14 7l1.5-1.5a2.5 2.5 0 013.5 3.5L17 10" />
      <path d="M6 15l-2 5 5-2" />
    </>
  ),
  tools: (
    <path d="M14.5 4.5a3.8 3.8 0 00-4.9 4.9l-5.3 5.3a1.5 1.5 0 000 2.1l.9.9a1.5 1.5 0 002.1 0l5.3-5.3a3.8 3.8 0 004.9-4.9l-2.3 2.3-2.1-.6-.6-2.1z" />
  ),
  // items
  asset: (
    <>
      <rect x="3" y="7" width="18" height="13" rx="2" />
      <path d="M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2" />
    </>
  ),
  box: (
    <>
      <path d="M3 8l9-5 9 5v8l-9 5-9-5z" />
      <path d="M3 8l9 5 9-5M12 13v8" />
    </>
  ),
  catalog: (
    <>
      <path d="M4 5a2 2 0 012-2h12v18H6a2 2 0 01-2-2z" />
      <path d="M8 7h6M8 11h6" />
    </>
  ),
  family: (
    <>
      <circle cx="12" cy="6" r="2.5" />
      <circle cx="6" cy="18" r="2.5" />
      <circle cx="18" cy="18" r="2.5" />
      <path d="M12 8.5v3M12 11.5L7 15.5M12 11.5l5 4" />
    </>
  ),
  fin: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v10M9.5 9.5c0-1 1-1.5 2.5-1.5s2.5.7 2.5 1.7-1 1.3-2.5 1.6-2.5.6-2.5 1.6 1 1.6 2.5 1.6 2.5-.5 2.5-1.5" />
    </>
  ),
  shows: (
    <>
      <path d="M4 5h16v11H4z" />
      <path d="M8 21h8M12 16v5M9 9l3 2-3 2z" />
    </>
  ),
  cal: (
    <>
      <rect x="3" y="4" width="18" height="17" rx="2" />
      <path d="M3 9h18M8 2v4M16 2v4" />
    </>
  ),
  tour: <path d="M3 12h4l3-7 4 14 3-7h4" />,
  sched: (
    <>
      <rect x="3" y="4" width="18" height="17" rx="2" />
      <path d="M3 9h18M8 13h3M8 17h6" />
    </>
  ),
  roster: (
    <>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20a6 6 0 0112 0M16 11h5M16 15h5M16 19h5" />
    </>
  ),
  pilot: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M5 21a7 7 0 0114 0" />
    </>
  ),
  dispatch: (
    <>
      <path d="M3 17h11V6H3z" />
      <path d="M14 9h4l3 3v5h-7" />
      <circle cx="7" cy="19" r="1.8" />
      <circle cx="17" cy="19" r="1.8" />
    </>
  ),
  vehicle: (
    <>
      <rect x="3" y="7" width="18" height="10" rx="2" />
      <circle cx="8" cy="19" r="1.6" />
      <circle cx="16" cy="19" r="1.6" />
      <path d="M3 12h18" />
    </>
  ),
  cust: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21a8 8 0 0116 0" />
    </>
  ),
  // A clipboard with a ticked line: a request someone is asking you to act on.
  request: (
    <>
      <path d="M8 4H6a1 1 0 00-1 1v15a1 1 0 001 1h12a1 1 0 001-1V5a1 1 0 00-1-1h-2" />
      <path d="M9 3h6v3H9zM8.5 12.5l2 2 4.5-4.5M9 18h6" />
    </>
  ),
  order: (
    <>
      <path d="M5 4h14l-1 16H6z" />
      <path d="M9 4V2h6v2M9 11h6" />
    </>
  ),
  transfer: <path d="M4 8h13l-3-3M20 16H7l3 3" />,
  rma: (
    <>
      <path d="M3 7h18v13H3z" />
      <path d="M3 7l3-4h12l3 4M9 12l3 3 3-3" />
    </>
  ),
  logs: (
    <>
      <path d="M4 4h16v16H4z" />
      <path d="M8 8h8M8 12h8M8 16h5" />
    </>
  ),
  analyst: (
    <>
      <path d="M3 3v18h18" />
      <path d="M7 15l4-5 3 3 5-7" />
    </>
  ),
  stats: (
    <>
      <rect x="4" y="12" width="4" height="8" />
      <rect x="10" y="7" width="4" height="13" />
      <rect x="16" y="3" width="4" height="17" />
    </>
  ),
  map: (
    <>
      <path d="M9 4L3 6v14l6-2 6 2 6-2V4l-6 2-6-2z" />
      <path d="M9 4v14M15 6v14" />
    </>
  ),
  fw: (
    <>
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <path d="M9 9h6v6H9z" />
      <path d="M9 2v2M15 2v2M9 20v2M15 20v2M2 9h2M2 15h2M20 9h2M20 15h2" />
    </>
  ),
  charge: <path d="M13 2L4 14h7l-1 8 9-12h-7z" />,
  scan: <path d="M4 8V5a1 1 0 011-1h3M20 8V5a1 1 0 00-1-1h-3M4 16v3a1 1 0 001 1h3M20 16v3a1 1 0 01-1 1h-3M3 12h18" />,
  // Luggage-tag outline: the sticker shape, with the punch hole reading as the
  // one filled dot so it survives at 16px.
  label: (
    <>
      <path d="M11.6 3H20a1 1 0 011 1v8.4a1 1 0 01-.3.7l-8 8a1 1 0 01-1.4 0l-8-8a1 1 0 010-1.4l8-8a1 1 0 01.7-.3z" />
      <circle cx="16.8" cy="7.2" r="1.4" fill="currentColor" stroke="none" />
    </>
  ),
  // chrome / utility
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="M21 21l-4-4" />
    </>
  ),
  bell: (
    <>
      <path d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.7 21a2 2 0 01-3.4 0" />
    </>
  ),
  chevron: <path d="M6 9l6 6 6-6" />,
  close: <path d="M6 6l12 12M18 6L6 18" />,
  star: <path d="M12 2l2 7h7l-5.5 4 2 7L12 17l-5.5 3 2-7L3 9h7z" />,
  bolt: <path d="M13 2L4 14h7l-1 8 9-12h-7z" />,
  arrow: <path d="M5 12h14M13 6l6 6-6 6" />,
  flerpie: (
    <>
      <path d="M21 12a8 8 0 01-11.4 7.2L4 20l1.1-4.3A8 8 0 1121 12z" />
      <path d="M12 7.6l.9 2.2 2.3.9-2.3.9-.9 2.2-.9-2.2-2.3-.9 2.3-.9z" />
    </>
  ),
  spark: (
    <>
      <path d="M12 2.5l1.9 6.1 6.1 1.9-6.1 1.9L12 18.5l-1.9-6.1L4 10.5l6.1-1.9z" />
      <path d="M19 15.5l.7 2.2 2.2.7-2.2.7L19 21.3l-.7-2.2-2.2-.7 2.2-.7z" />
      <circle cx="5" cy="19" r="1.2" fill="currentColor" stroke="none" />
    </>
  ),
  dot: <circle cx="12" cy="12" r="3" />,
};

export interface IconProps {
  name: string;
  className?: string;
  strokeWidth?: number;
}

export const Icon: React.FC<IconProps> = ({ name, className, strokeWidth = 1.5 }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {ICONS[name] ?? ICONS.dot}
  </svg>
);

export default Icon;
